import script from "./print-order-report.vue?vue&type=script&setup=true&lang=ts"
export * from "./print-order-report.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__